type TableBodyProps = {
  children: React.ReactNode;
};

const TableBody = ({ children }: TableBodyProps) => (
  <tbody className="divide-y divide-gray-200 bg-white">{children}</tbody>
);

export { TableBody };
